import { createContext, useContext, useMemo, useState } from 'react';

// SideNavContext lets a page swap the left navigation for a context-specific
// menu (e.g. a service's own menu). When `nav` is null the sidebar renders its
// default console navigation.
//
// nav shape: { title, subtitle?, backTo?, items: [{ label, to, icon? }] }
const SideNavContext = createContext(null);

export function SideNavProvider({ children }) {
  const [nav, setNav] = useState(null);
  const value = useMemo(() => ({ nav, setNav }), [nav]);
  return <SideNavContext.Provider value={value}>{children}</SideNavContext.Provider>;
}

export function useSideNav() {
  const ctx = useContext(SideNavContext);
  if (!ctx) throw new Error('useSideNav must be used within a SideNavProvider');
  return ctx;
}
